<template>
   <div>
     <HabitCard
        :closeEvent="() => showHabitCard = !showHabitCard"
        :habit="habit"
        v-if="showHabitCard"
      >
      <div class="buttons">
        <b-button
          type="is-primary"
          inverted outlined
          expanded
          @click="showWebhook('NFC')"
        >
          {{ $t(`${translationPath}.webhookTitle`) }}
        </b-button>

        <b-button
          type="is-primary is-light"
          expanded
          inverted outlined
          @click="addUrlToHabit"
        >
          Add url to habit (show up when you pass)
        </b-button>

        <b-button
          type="is-primary is-light"
          inverted outlined
          expanded
          @click="changeTime"
        >
        {{ $t(`${translationPath}.changeHour`) }}
        </b-button>

        <b-button
          type="is-danger"
          expanded
          @click="removeHabitEvent"
          v-if="isToday"
        >
          {{ $t(`${translationPath}.remove`) }}
        </b-button>
      </div>
    </HabitCard>
    <habit-item-element
      :isCheckObject="isCheckObject"
      :succesRate="stats"
      :percent="percent"
      :checkEvent="checkEvent"
      :habit="habitObject"
      :series="series"
    >
    <p @click="showHabitCard = !showHabitCard" style="padding: 13px; margin-right: 20px;"
      role="button">
      <font-awesome-icon
        size="lg" icon="pen" />
    </p>
    </habit-item-element>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapState } from 'vuex';
import HabitItemElement from './HabitItemElement.vue';
import ItemModal from './ItemModal.vue';
import Calendar from './Calendar.vue';
import habitHelper from '../../../helpers/habitHelper';
import HabitCard from './HabitCard.vue';

export default {
  props: {
    habit: Object,
    addActivityLog: Function,
    removeActivityLog: Function,
    activityLogs: Array,
    selectedDay: String,
    editActivityHabitsEvent: Function,
    isActiveParent: Boolean,
    daysArr: Array,
  },
  components: {
    HabitItemElement,
    HabitCard,
  },
  data() {
    return {
      checkbox: false,
      habitTime: this.habit?.time ? this.$moment(this.habit.time, 'HHmm').seconds(0).milliseconds(0).toDate() : '',
      translationPath: 'habit',
      habitObject: this.habit,
      series: null,
      stats: null,
      showHabitCard: false,
    };
  },
  watch: {
    isActiveParent: 'update',
  },
  mounted() {
    this.calcuklateStatsForHabit();
    this.$store.subscribe((mutations) => {
      const isThatType = mutations.type === 'habitsDashboard/ADD_HABIT_LOG';
      if (isThatType && mutations.payload.habitLocalId === this.habit.localId) {
        this.calcuklateStatsForHabit();
      }
    });
  },
  computed: {
    ...mapState({
      user: (state) => state.userStore.user,
      nick: (state) => state.userStore.nick,
      isOnline: (state) => state.applicationStore.isOnline,
    }),
    percent() {
      return Number(((this.stats?.coundSucces / this.stats?.count) * 100).toFixed(0));
    },
    userToken() {
      return `${this.nick}@${this.user.uid.substr(this.user.uid.length - 3)}`;
    },
    isCheckObject() {
      return habitHelper.isHabitDoneForDay(this.selectedDay, this.habit);
    },
    isToday() {
      return this.$moment(this.selectedDay).startOf('day').isSame(this.$moment(), 'day');
    },
    habitNameObject() {
      const text = this.habit.name.replace(/(?:https?|ftp):\/\/[\n\S]+/g, '');
      const url = this.habit.name.match(/(?:https?|ftp):\/\/[\n\S]+/g);
      return {
        text,
        url: url ? url[0] : false,
      };
    },
    isIos() {
      const userAgent = window.navigator.userAgent.toLowerCase();
      return /iphone|ipad|ipod/.test(userAgent);
    },
  },
  methods: {
    calcuklateStatsForHabit() {
      this.series = habitHelper.createSeriesForHabit(_.cloneDeep(this.habit));
      this.stats = habitHelper.getStatsFromToForHabit(_.cloneDeep(this.habit), this.daysArr);
    },
    ...mapActions({
      addPoints: 'pointsStore/addPoints',
      removePoints: 'pointsStore/removePoints',
      editActivityHabits: 'habitsDashboard/editActivityHabits',
      createGlobalId: 'habitsDashboard/createGlobalId',
    }),
    async checkEvent() {
      const activityLog = {
        name: this.habit.name,
        created: this.$moment().toISOString(),
        date: this.selectedDay,
        habitId: this.habit.firekey,
        habitGlobalId: this.habit.globalId ? this.habit.globalId : null,
        localId: this.$uniqueId(),
        habitLocalId: this.habit.localId ? this.habit.localId : null,
      };

      if (!this.isCheckObject.isDone) {
        await this.addActivityLog(activityLog);
        setTimeout(() => {
          this.calcuklateStatsForHabit();
        }, 100);
        if (this.habitObject.habitUrl) {
          this.$buefy.snackbar.open({
            message: 'Habit passed',
            type: 'is-success',
            position: 'is-bottom',
            actionText: 'Your Link',
            duration: 5000,
            cancelText: 'ok',
            onAction: () => {
              window.open(this.habitObject.habitUrl);
            },
          });
        }
      } else {
        if (!this.user.uid || !this.isOnline) return;
        await this.removeActivityLog({ habit: this.habit, day: this.selectedDay });
        setTimeout(() => {
          this.calcuklateStatsForHabit();
        }, 100);
      }
    },
    removeHabitEvent() {
      this.$buefy.dialog.confirm({
        title: this.$t(`${this.translationPath}.removeDialogTitle`),
        message: this.$t(`${this.translationPath}.removeDialogText`),
        confirmText: this.$t(`${this.translationPath}.removeDialogConfirm`),
        cancelText: this.$t(`${this.translationPath}.removeDialogCancel`),
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.editActivityHabitsEvent(this.habit),
      });
    },
    clickName() {
      this.checkEvent();
    },
    update() {
      this.clickName(this.isActiveParent);
    },
    clickClose() {
      const isTimeSame = this.$moment(this.habitTime).format('HHmm') === this.habit.time;
      if (!isTimeSame) {
        const itemToUpdate = {
          ...this.habit,
          time: this.$moment(this.habitTime).format('HHmm'),
        };
        this.editActivityHabits(itemToUpdate);
      }
    },
    changeTime() {
      this.$buefy.dialog.prompt({
        message: this.$t(`${this.translationPath}.changeTimeDialogMessage`),
        inputAttrs: {
          type: 'time',
        },
        trapFocus: true,
        onConfirm: (value) => {
          this.habitTime = this.$moment(value, 'HH:mm').seconds(0).milliseconds(0).toDate();
          this.$buefy.toast.open(`${this.$t(`${this.translationPath}.changeTimeDialogInfo`)} ${value}`);
          this.clickClose();
        },
      });
    },
    addUrlToHabit() {
      this.$buefy.dialog.prompt({
        message: 'Add url to habit',
        inputAttrs: {
          type: 'string',
        },
        trapFocus: true,
        onConfirm: (value) => {
          this.$buefy.toast.open('We add the url for you');
          const itemToUpdate = {
            ...this.habit,
            habitUrl: value,
          };
          this.editActivityHabits(itemToUpdate);
        },
      });
    },
    async showWebhook(type) {
      if (!this.habit.globalId) {
        this.habit.globalId = await this.createGlobalId(this.habit);
      }
      const text = this.$t(`${this.translationPath}.webhook`);

      this.$buefy.modal.open({
        parent: this,
        component: ItemModal,
        trapFocus: true,
        fullScreen: true,
        props: {
          webhook: `${window.location.origin}/short?id=${this.habit.globalId}`,
          globalId: this.habit.globalId,
          type,
          generateQRCode: this.downloadQRCode,
          text,
          isIos: this.isIos,
        },
      });
    },
    async downloadQRCode() {
      if (this.habit.globalId) {
        window.open(`${window.location.origin}/qrcode?key=${this.habit.globalId}`, '_blank');
      }
    },
    openCalendar() {
      this.$buefy.modal.open({
        parent: this,
        component: Calendar,
        trapFocus: true,
        fullScreen: true,
        props: {
          activityLogs: this.activityLogs,
          habit: this.habit,
        },
      });
    },

  },
};
</script>

<style scoped lang="scss">
  @media screen and (max-width: 1023px) {
    ::v-deep .dropdown.is-mobile-modal > .dropdown-menu {
      border-top: 7px solid $brand;
      border-bottom: 4px solid $brand;
      border-radius: 5px;
      padding-top: 0px;
    }
  }
  ::v-deep .dropdown .background {
    backdrop-filter: blur(16px) saturate(180%);
    -webkit-backdrop-filter: blur(16px) saturate(180%);
    // background-color: rgba(255, 255, 255, 0.55);
  }
  ::v-deep .dropdown-content {
    border-top: 2px solid $brand;
    border: none;
    box-shadow: none;
    background: $background-light-color;
  }
  ::v-deep a.dropdown-item:is(.is-disabled) {
    font-weight: 700;
    color: $font-dark-color;
    border-top: 2px solid $brand;
  }
  ::v-deep a.dropdown-item:not(.is-disabled) {
    font-weight: 700;
    color: $font-dark-color;
    border-top: 2px solid $brand;
  }
</style>
